import MasterAnnouncementsModel from '../Apis/MasterAnnouncements.js'
import Controller from './Controller.js';

export default class MasterAnnouncementsController extends Controller {

    constructor() {
        super(new MasterAnnouncementsModel());
    }


}